import addressee from '../../defaultFieldDefinitions/Addressee';
import addressLine2 from '../../defaultFieldDefinitions/AddressLine2';
import companyName from '../../defaultFieldDefinitions/CompanyName';
import nameNumber from '../../defaultFieldDefinitions/HouseNameOrNumber';
import postCode from '../../defaultFieldDefinitions/PostCode';
import streetName from '../../defaultFieldDefinitions/StreetName';
import townCity from '../../defaultFieldDefinitions/TownCity';
import * as max from '../../max-length-validators';
import * as required from '../../required-validators';

const FieldDefinitionBR = [
  addressee,
  postCode,
  companyName,
  nameNumber,
  streetName,
  addressLine2,
  townCity,
  {
    name: 'county',
    label: 'checkout.address.field.label.county.text',
    maxLength: 35,
    validate: [max.lengthAddress(35), required.county],
    required: true,
  },
];

export default FieldDefinitionBR;
